// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'
import 'firebase/auth'
import {
	firebaseInit,
	db
} from './resources/firebase'
import {
	getNotifications
} from './api/notifications'
import {
	getFeedback
} from './api/feedback'

import VueDragscroll from 'vue-dragscroll'
import Vuelidate from 'vuelidate'
import VuelazyLoad from 'vue-lazyload'
// import persistentState from 'vue-persistent-state'
import './resources/filters'
import {
	vxStore
} from './store/vuex_store'
import * as Sentry from '@sentry/browser'
import {
	Vue as VueIntegration
} from '@sentry/integrations'
import NProgress from 'nprogress'
import '../node_modules/nprogress/nprogress.css'
import VueToasted from 'vue-toasted'
import VueCarousel from 'vue-carousel'
import VueChatScroll from 'vue-chat-scroll'
require('vue-ionicons/ionicons.css')

// import InstantSearch from 'vue-instantsearch'
// console.log(userStore)

Vue.config.productionTip = false
Vue.config.ignoredElements = [/^ion-/]
Vue.config.performance = true
NProgress.configure({
	easing: 'ease',
	speed: 1000
});
Vue.use(firebaseInit)
Vue.use(VueDragscroll)
Vue.use(Vuelidate)
Vue.use(VuelazyLoad, {
	attempt: 2,
	error: '../static/android-chrome-192x192.png'
})
Vue.use(VueToasted)
Vue.use(VueCarousel)
Vue.use(VueChatScroll)
// Vue.use(InstantSearch)
// Vue.use(persistentState, store.state)
Sentry.init({
	dsn: 'https://675921f78210466aaddd51c8766f006b@o203272.ingest.sentry.io/1318273',
	// integrations: [new VueIntegration({
	// 	Vue,
	// 	attachProps: true
	// })],
});

router.beforeResolve((to, from, next) => {
	if (to.path) {
		NProgress.start()
	}

	const relativeWrapper = [...document.querySelectorAll('.relative-wrapper')]

	if (to.name === 'auth') {
		relativeWrapper.forEach(item => {
			item.style.display = 'none'
		})
	} else {
		relativeWrapper.forEach(item => {
			item.style.display = 'block'
		})
	}

	if (to.name === 'about') {
		document.title = 'Stack NG | About'
	} else {
		document.title = 'Stack NG'
	}

	next()
})

router.beforeEach((to, from, next) => {
	if (vxStore.state.app.app.menuOpen) {
		vxStore.state.app.app.menuOpen = false
	}
	setTimeout(() => {
		next()
	}, 500)
})

router.afterEach((to, from) => {
	NProgress.done()
	if (to.name !== 'auth') {
		const app = document.querySelector('#app')
		app.classList.remove('background-change')
	}
})

//To ensure when user refreshes, they remain logged in
let app

const initialize = () => {
	if (!app) {
		/* eslint-disable no-new */
		app = new Vue({
			router,
			store: vxStore,
			components: {
				App
			},
			template: '<App/>'
		}).$mount('#app')
	}
}

firebase.auth().onAuthStateChanged(async (user) => {
	if (user) {
		let isVerified = null
		await vxStore.dispatch('setAuthUser', user)

		db.collection("users").where("userID", "==", vxStore.state.user.authUser.uid)
			.get()
			.then((snapshot) => {
				snapshot.forEach(async (doc) => {
					await vxStore.dispatch('setUserInfo', doc.data())
					await vxStore.commit('setUserStats', doc.data())
					vxStore.state.user.user.bookmarkedStories = doc.data().stories.reverse()
					isVerified = doc.data().emailVerified
				})
			})
			.then(() => {
				if (!isVerified) {
					db.collection("users").doc(vxStore.state.user.authUser.uid)
						.update({
							"emailVerified": user.emailVerified
						})
						.catch((error) => {
							// console.log(error)
							throw new Error(error)
						})
				}
			})
			.then(() => {
				getNotifications(vxStore)
				getFeedback(vxStore)
			})
			.catch(error => {
				// console.log(error)
				throw new Error(error)
			})
	} else {
		vxStore.dispatch('setAuthUser', null)
	}

	initialize()
})

// new Vue({
//   el: '#app',
//   router,
//   store: vxStore,
//   components: { App },
//   template: '<App/>'
// })



// WEBPACK FOOTER //
// ./src/main.js